import { documentToReactComponents, Options } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import cn from "clsx";
import { useTranslations } from "next-intl";

import { ArtworkChecks } from "@/clients/contentful";
import { ArtworkCheckListComponent } from "@/features/contentful/components/artwork-check-component/artwork-check-list-component";
import { defaultDocumentToReactComponentsOptions } from "@/features/contentful/default-document-to-react-component-options";

const renderOptions: Options = {
  ...defaultDocumentToReactComponentsOptions,
  renderNode: {
    ...defaultDocumentToReactComponentsOptions.renderNode,
    [BLOCKS.HEADING_6]: (node, children) => <span className="font-semibold">{children}</span>,
  },
};

export const ArtworkCheckComponent = ({
  artworkChecks,
  className = "",
}: {
  artworkChecks: ArtworkChecks;
  className?: string;
}) => {
  const t = useTranslations("common");
  return (
    <div className={cn("flex flex-col", className)}>
      <div className="mb-6 flex justify-between px-0 lg:mb-8 lg:px-3">
        <ArtworkCheckListComponent
          className="basis-[48%] lg:basis-[46%]"
          titleKey="text-essential-checks"
          list={artworkChecks.fields.essentialChecks!.fields.list}
        />
        <ArtworkCheckListComponent
          className="basis-[48%] lg:basis-[46%]"
          titleKey="text-expert-checks"
          list={artworkChecks.fields.expertChecks!.fields.list}
          extraItem={t("text-all-checks-plus")}
        />
      </div>
      {artworkChecks.fields.additionalInfo && (
        <div className="mb-6 text-center lg:mb-8">
          {documentToReactComponents(artworkChecks.fields.additionalInfo, renderOptions)}
        </div>
      )}
    </div>
  );
};
